import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import history from '@/services/history'

import ScaleLoader from 'react-spinners/ScaleLoader'
import {
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { Close, MoreHoriz } from '@material-ui/icons'
import { Back } from '@/components/Icons'

import {
  OpenSidebarButton,
  StyledPageBody,
  StyledPageContent,
  StyledPageContainer,
  StyledPageHeader,
  StyledSlide,
  StyledSlideContainer,
  LoaderContainer,
} from './styles'

import { colors } from '@/theme'
import * as medias from '@/consts/medias'

// PageContainer
export function PageContainer({ children, variant, ...props }) {
  return (
    <StyledPageContainer {...props} variant={variant}>
      {children}
    </StyledPageContainer>
  )
}

PageContainer.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
}

PageContainer.defaultProps = {
  variant: 'default',
}

// PageHeader
export function PageHeader({ children, title, showReturn, ...props }) {
  return (
    <StyledPageHeader {...props}>
      {title && (
        <Typography component="h3">
          {showReturn && (
            <IconButton
              onClick={history.goBack}
              title="Voltar"
              size="small"
              color="primary"
            >
              <Back fontSize="small" />
            </IconButton>
          )}

          {title}
        </Typography>
      )}

      {children}
    </StyledPageHeader>
  )
}

PageHeader.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  showReturn: PropTypes.bool,
}

// PageBody
export function PageBody({ children }) {
  return <StyledPageBody>{children}</StyledPageBody>
}

PageBody.propTypes = {
  children: PropTypes.node,
}

// PageContent
export function PageContent(props) {
  const { children, variant, loading, printable } = props

  return (
    <StyledPageContent
      variant={variant}
      className={clsx({ printable, loading })}
    >
      {/* {children} */}

      {loading ? (
        <LoaderContainer>
          <ScaleLoader radius={10} color={colors.color700} />
        </LoaderContainer>
      ) : <>{children}</>}
    </StyledPageContent>
  )
}

PageContent.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  printable: PropTypes.bool,
  loading: PropTypes.bool,
}

PageContent.defaultProps = {
  variant: 'default',
  loading: false,
  printable: true,
}

// PageSlideSidebar
export function PageSlideSidebar(props) {
  const { children, initialShifted, openTitle, mountOnEnter, unmountOnExit } =
    props

  const isMobile = useMediaQuery(medias.xs)
  const [shifted, setShifted] = useState(false)

  useEffect(() => {
    setShifted(isMobile ? false : initialShifted)
  }, [isMobile, initialShifted])

  function handleShift() {
    setShifted((previousShifted) => !previousShifted)
  }

  return (
    <>
      <StyledSlideContainer className={clsx({ closed: !shifted })}>
        <StyledSlide
          direction="right"
          in={shifted}
          mountOnEnter={mountOnEnter}
          unmountOnExit={unmountOnExit}
        >
          <div>
            <IconButton size="small" color="primary" onClick={handleShift}>
              <Close />
            </IconButton>

            {children}
          </div>
        </StyledSlide>
      </StyledSlideContainer>

      {!shifted && (
        <Tooltip title={openTitle} arrow placement="right">
          <OpenSidebarButton size="small" onClick={handleShift}>
            <MoreHoriz />
          </OpenSidebarButton>
        </Tooltip>
      )}
    </>
  )
}

PageSlideSidebar.propTypes = {
  children: PropTypes.node,
  initialShifted: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  mountOnEnter: PropTypes.bool,
  openTitle: PropTypes.string,
}

PageSlideSidebar.defaultProps = {
  initialShifted: true,
  unmountOnExit: false,
  mountOnEnter: true,
  openTitle: 'Mais informações',
}
